export const getLocalePrefix = (language: string) => {
  return language === 'nl' ? '' : `/${language}`
}
